<template>
  <div>
    <b-sidebar
      id="sidebar-customer"
      v-model="showSlide"
      backdrop
      shadow
      backdrop-variant="dark"
      right
      aria-labelledby="sidebar-customer-title"
      @hidden="hide()"
      no-header
    >
      <template>
        <div v-if="isLoading">
          <OtherLoading />
        </div>
        <div v-else>
          <div
            class="m-2 d-flex justify-content-between align-items-center p-2"
          >
            <label class="header-text">ข้อมูลลูกค้า</label>
            <div class="pointer" @click="hide()">
              <b-icon icon="x-circle-fill"></b-icon>
            </div>
          </div>

          <div>
            <div class="p-2 detail-panel">
              <div
                class="pb-2 d-flex justify-content-between align-items-center"
              >
                <p>ชื่อ <span class="text-danger">*</span></p>
                <InputText
                  textFloat=""
                  v-model="detail.first_name_th"
                  class="m-0 w-75"
                  placeholder="ชื่อ"
                  type="text"
                />
              </div>
              <div
                class="pb-2 d-flex justify-content-between align-items-center"
              >
                <p>นามสกุล</p>
                <InputText
                  textFloat=""
                  v-model="detail.last_name_th"
                  class="m-0 w-75"
                  placeholder="นามสกุล"
                  type="text"
                />
              </div>
              <div
                class="pb-2 d-flex justify-content-between align-items-center"
              >
                <p>Name</p>
                <InputText
                  textFloat=""
                  v-model="detail.first_name_en"
                  class="m-0 w-75"
                  placeholder="Firstname"
                  type="text"
                />
              </div>
              <div
                class="pb-2 d-flex justify-content-between align-items-center"
              >
                <p>Surname</p>
                <InputText
                  textFloat=""
                  v-model="detail.last_name_en"
                  class="m-0 w-75"
                  placeholder="Lastname"
                  type="text"
                />
              </div>

              <div
                class="pb-2 d-flex justify-content-between align-items-center"
              >
                <p>โทร.</p>
                <InputText
                  textFloat=""
                  v-model="detail.telephone"
                  class="m-0 w-75"
                  placeholder="เบอร์โทรศัพท์"
                  type="text"
                />
              </div>
              <div
                class="pb-2 d-flex justify-content-between align-items-center"
              >
                <p>สมาชิก</p>
                <InputText
                  textFloat=""
                  disabled
                  v-model="detail.member_id"
                  class="m-0 w-75"
                  placeholder="เบอร์โทรศัพท์"
                  type="text"
                />
              </div>
              <div
                class="pb-2 d-flex justify-content-between align-items-center"
              >
                <p>คะแนนสะสม</p>
                <InputText
                  textFloat=""
                  disabled
                  v-model="detail.sumPoint"
                  class="m-0 w-75"
                  placeholder="เบอร์โทรศัพท์"
                  type="text"
                />
              </div>
            </div>
            <div class="text-center mt-3">
              <b-button class="default-btn radius-btn w-75" @click="gotoReport"
                ><span>รายการขายย้อนหลัง</span></b-button
              >
            </div>
          </div>
        </div>
      </template>

      <template #footer>
        <div class="text-center">
          <div class="mb-2 w-100">
            <b-button
              class="radius-btn text-white w-75 bg-main"
              @click="submitForm"
              ><span>บันทึก</span></b-button
            >
          </div>
        </div>
      </template>
    </b-sidebar>
  </div>
</template>

<script>
import OtherLoading from "@/components/loading/OtherLoading";
import InputText from "@/components/inputs/InputText";
export default {
  name: "SlideCustomer",
  components: { OtherLoading, InputText },
  props: {
    search: {
      type: String,
      isRequired: true,
    },
    user: {
      type: Object,
      isRequired: true,
    },
  },
  data() {
    return {
      showSlide: false,
      filter: {
        search: "",
      },
      detail: {
        user_guid: "",
        user_id: "",
        member_id: "",
        first_name_th: "",
        last_name_th: "",
        telephone: "",
        point: 0,
      },
      isLoading: false,
    };
  },
  methods: {
    show() {
      this.filter.search = this.search;
      this.getUserDetail();
      this.showSlide = true;
    },
    hide() {
      this.showSlide = false;
    },
    getUserDetail() {
      this.isLoading = true;
      this.axios
        .get(
          `${this.$baseUrl}/customer/user_lookup_byid/${
            this.user.user_guid
          }/${this.$cookies.get("branch_id")}`
        )
        .then((data) => {
          if (data.result == 1) {
            this.detail = data.detail;
            this.detail.sumPoint = data.detail.center_point + data.detail.point;
          }
          this.isLoading = false;
        });
    },
    searchUser() {
      this.$emit("onChangehUser", this.filter.search, "change");
    },
    handlePushMessage(e) {
      if (e.keyCode === 13 && !e.shiftKey) {
        e.preventDefault();
        this.searchUser();
      }
    },
    gotoReport() {
      this.$router.push(`/report?memberID=${this.user.member_id}`);
    },
    submitForm() {
      this.detail.firstname = this.detail.first_name_th;
      this.detail.lastname = this.detail.last_name_th;
      this.$emit("onChangeUserData", this.detail);
    },
  },
};
</script>

<style scoped></style>
